import { Box, Paper, Group, ThemeIcon, Text, Button, Flex } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { STATUS_COLORS } from "@/components/shared/constants/general.const";

const MAKE_PAYMENT_BTN_STYLES = {
  root: {
    backgroundColor: "#04305c",
    color: "#ffffff",
    border: "1px solid #04305c",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#032847",
      borderColor: "#032847",
    },
  },
};

/** Yellow anonymous-preview banner with Make payment CTA (above workspace tabs). */
export default function PreviewPaymentBanner({
  onMakePayment,
  userPaid,
}: {
  onMakePayment: () => void;
  userPaid: boolean;
}) {
  return (
    <Box mb="md">
      <Paper
        radius="lg"
        p="md"
        style={{
          border: `1px solid ${STATUS_COLORS.WARNING.border}`,
          backgroundColor: STATUS_COLORS.WARNING.bg,
        }}
      >
        <Flex justify="space-between" align="center" gap="md" wrap="wrap">
          <Group gap="sm" wrap="nowrap" align="flex-start" style={{ flex: 1, minWidth: 0 }}>
            <ThemeIcon
              radius="xl"
              size={36}
              variant="light"
              style={{
                flexShrink: 0,
                backgroundColor: "rgba(225, 113, 0, 0.12)",
                color: STATUS_COLORS.WARNING.icon,
              }}
            >
              <IconInfoCircle size={18} color={STATUS_COLORS.WARNING.icon} />
            </ThemeIcon>
            <Box style={{ minWidth: 0 }}>
              <Flex align="baseline" gap="xs" wrap="wrap" mb={4}>
                <Text fw={700} fz="sm" c={STATUS_COLORS.WARNING.text}>
                  {userPaid ? "Waiting for partner payment" : "Anonymous preview"}
                </Text>
                <Text fz="xs" fw={400} c={STATUS_COLORS.WARNING.text} style={{ opacity: 0.85 }}>
                  {userPaid ? "You paid" : "Pay to unlock full profile"}
                </Text>
              </Flex>
              <Text fz="sm" c={STATUS_COLORS.WARNING.text} lh={1.45}>
                {userPaid
                  ? "You see anonymized partner details until they pay. Chat, documents, and contact info unlock after both parties pay."
                  : "You are viewing anonymized company details. Complete payment to unlock contact information, chat, questionnaires, and document sharing."}
              </Text>
            </Box>
          </Group>

          {!userPaid ? (
            <Button radius="md" onClick={onMakePayment} styles={MAKE_PAYMENT_BTN_STYLES}>
              Make payment
            </Button>
          ) : (
            <Button variant="default" radius="md" disabled>
              Payment completed
            </Button>
          )}
        </Flex>
      </Paper>
    </Box>
  );
}
